export default __webpack_public_path__ + "static/media/36I-114287_-20976_0.a78264cc.jpg";